import { memo } from "react";
import { BzButton } from '../components';
import { Container, Row, Col } from "react-bootstrap";

const ZeroStates = ({ heading, subText, btnText, btnClass, subTextClass, icon, handleOnClick }) => {
    return (
        <Container fluid className='g-0'>
            <Row className='g-0'>
                <Col className='justify-content-center align-items-center text-center'>
                    <div className={icon}></div>
                    <div className='font-medium font-size4 color-text mb-1' data-testid="no-data">{heading}</div>
                    <div className='font-regular font-size2 color-nodata' data-testid="no-dataSubtext">{subText}</div>
                    {btnText && <BzButton className={btnClass} onClick={handleOnClick}>{btnText}</BzButton>}
                </Col>
            </Row>
        </Container>
    );
};

export default memo(ZeroStates);